import { Plus } from 'lucide-react';

import CardBlock from '@/components/CardBlock';
import { Button } from '@/components/ui/button';
import { DETAIL_MODE, DETAIL_TYPE, useDetailMode } from '@/hooks/useDetailMode';

const ResponsibilitiesView = ({ document, setDocument }) => {
  const { mode } = useDetailMode(DETAIL_TYPE.DOCUMENT);

  const responsibilitiesData = document?.responsibilities?.formData || {};
  const responsibilitiesRows = document?.responsibilities?.rows || [];

  const updateResponsibilities = (nextPartial) => {
    setDocument((prev) => ({
      ...prev,
      responsibilities: {
        ...prev.responsibilities,
        ...nextPartial,
      },
    }));
  };

  const handleAddTextClick = () => {
    updateResponsibilities({
      rows: [
        ...responsibilitiesRows,
        {
          id: +new Date(),
          type: 'multi-text',
        },
      ],
    });
  };

  return (
    <>
      <div className="space-y-4">
        {responsibilitiesRows.map(({ id, type }) => (
          <CardBlock
            fieldPlaceholder="Add Responsibility"
            formData={responsibilitiesData}
            id={id}
            key={id}
            mode={mode}
            sections={responsibilitiesRows}
            setFormData={(updater) =>
              updateResponsibilities({
                formData: updater(responsibilitiesData),
              })
            }
            setSections={(next) => updateResponsibilities({ rows: next })}
            type={type}
            titlePlaceholder="Add Designation"
          />
        ))}
      </div>
      {mode !== DETAIL_MODE.STATIC && (
        <div className="flex gap-4 mt-4">
          <Button variant="outline" onClick={handleAddTextClick}>
            <Plus />
            Add Designation
          </Button>
        </div>
      )}
    </>
  );
};

export default ResponsibilitiesView;
